import { TabViews } from '@dfl/mui-admin-layout';
import { CAMPAIGN_TYPE_ENUM } from './type.enum';

export const campaignViewTabs: TabViews = {
  [CAMPAIGN_TYPE_ENUM.email]: {
    title: `campaignTypeOptions.${CAMPAIGN_TYPE_ENUM.email}.name`,
    filters: {
      type: 'TERM',
      field: 'type',
      value: CAMPAIGN_TYPE_ENUM.email,
    },
  },
  [CAMPAIGN_TYPE_ENUM.banner]: {
    title: `campaignTypeOptions.${CAMPAIGN_TYPE_ENUM.banner}.name`,
    filters: {
      type: 'TERM',
      field: 'type',
      value: CAMPAIGN_TYPE_ENUM.banner,
    },
  },
  [CAMPAIGN_TYPE_ENUM.itemsPromotion]: {
    title: `campaignTypeOptions.${CAMPAIGN_TYPE_ENUM.itemsPromotion}.name`,
    filters: {
      type: 'TERM',
      field: 'type',
      value: CAMPAIGN_TYPE_ENUM.itemsPromotion,
    },
  },
};
